import { render, staticRenderFns } from "./ObjectBreadcrumbsV2.vue?vue&type=template&id=293b1a52&scoped=true&"
import script from "./ObjectBreadcrumbsV2.vue?vue&type=script&lang=ts&"
export * from "./ObjectBreadcrumbsV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293b1a52",
  null
  
)

export default component.exports